import { useLayoutEffect, useState } from 'react';

import { isNarrowWidth } from './narrowColumns';

export function useDataTableNarrow(element: HTMLElement | null) {
  const [narrow, setNarrow] = useState(false);

  useLayoutEffect(() => {
    if (!element) {
      return;
    }

    const measure = () => {
      const next = isNarrowWidth(element.getBoundingClientRect().width);
      setNarrow((current) => (current === next ? current : next));
    };

    measure();
    if (typeof ResizeObserver === 'undefined') {
      return;
    }

    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);

  return element ? narrow : false;
}
